import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  selections: null,
}

const getters = {
  supportingInfoVisibilitySelections(userSelectionParams) {
    const url = `/MaintenanceIssue/${userSelectionParams.issueId}/SupportingInformations`
    return axios.get(url)
  },
}

const saves = {
  userSelections(userSelectionParams) {
    const url = `/MaintenanceIssue/${userSelectionParams.issueId}/SupportingInformation`
    return axios
      .post(url, {
        typeId: userSelectionParams.typeId,
        content: JSON.stringify({ selections: userSelectionParams.selections }),
        caption: userSelectionParams.caption,
      })
      .catch(error => error)
  },
}

export default class SelectionsService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
